<template>
  <div class="w-full h-full">
    <template v-if="src">
      <img
        class="rounded-circle"
        :src="src"
        :alt="name"
        :style="{ height: size + 'px', width: size + 'px' }"
      />
    </template>
    <template v-else>
      <div
        class="h-full w-full rounded-circle flex justify-center items-center"
        :style="{ backgroundColor: bgColor }"
      >
        <div class="text-white-primary text-2xl absolute">
          {{ showContent }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { generateContrastColor } from '@/utils/style';

const props = defineProps({
  src: {
    type: String,
    default: undefined,
  },
  name: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 160,
  },
});

const bgColor = computed(() => generateContrastColor(props.name));
const showContent = computed(() => props.name?.slice(0, 1).toUpperCase());
</script>

<style scoped lang="scss"></style>
